import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function Register({ onSwitch }) {
  const { register } = useAuth();
  const [form, setForm]       = useState({ full_name:'', phone:'', password:'' });
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);

  const handle = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await register(form);
    } catch (err) {
      setError(err.response?.data?.error || 'خطأ في التسجيل');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logo}>🚀</div>
        <h1 style={styles.title}>حساب جديد</h1>
        <p style={styles.subtitle}>سجّل وابدأ التوصيل دلوقتي</p>
        <form onSubmit={handleSubmit}>
          <input style={styles.input} name="full_name" placeholder="الاسم كامل" value={form.full_name} onChange={handle} required />
          <input style={styles.input} name="phone" type="tel" placeholder="رقم الهاتف" value={form.phone} onChange={handle} required />
          <input style={styles.input} name="password" type="password" placeholder="كلمة المرور" value={form.password} onChange={handle} required />
          {error && <p style={styles.error}>{error}</p>}
          <button style={styles.btn} type="submit" disabled={loading}>
            {loading ? 'جاري التسجيل...' : 'إنشاء حساب'}
          </button>
        </form>
        <p style={styles.switchText}>
          عندك حساب؟{' '}
          <span style={styles.link} onClick={onSwitch}>سجّل دخول</span>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'linear-gradient(135deg,#10b981,#059669)', padding:'20px' },
  card:      { background:'#fff', borderRadius:'20px', padding:'40px 30px', width:'100%', maxWidth:'400px', boxShadow:'0 20px 60px rgba(0,0,0,0.3)', textAlign:'center' },
  logo:      { fontSize:'50px', marginBottom:'10px' },
  title:     { fontSize:'28px', fontWeight:'bold', color:'#333', margin:'0 0 5px' },
  subtitle:  { color:'#888', marginBottom:'30px', fontSize:'14px' },
  input:     { width:'100%', padding:'14px', margin:'8px 0', borderRadius:'10px', border:'1px solid #ddd', fontSize:'16px', boxSizing:'border-box', textAlign:'right', direction:'rtl' },
  btn:       { width:'100%', padding:'14px', background:'linear-gradient(135deg,#10b981,#059669)', color:'#fff', border:'none', borderRadius:'10px', fontSize:'16px', fontWeight:'bold', cursor:'pointer', marginTop:'10px' },
  error:     { color:'#e74c3c', fontSize:'14px', margin:'5px 0' },
  switchText:{ marginTop:'20px', color:'#888', fontSize:'14px' },
  link:      { color:'#10b981', cursor:'pointer', fontWeight:'bold' },
};
